import { GraphData } from '../types';

const getUnrelatedNodes = (id: string, allData: GraphData) => {
  const related = allData.edges
    .filter((e) => e.fromVertexId === id || e.toVertexId === id)
    .flatMap((e) => [e.toVertexId, e.fromVertexId])
    .filter((id, i, arr) => arr.indexOf(id) === i);

  const unrelated = allData.vertices
    .filter((v) => related.indexOf(v.id) === -1)
    .map((v) => v.id);
  return unrelated;
};

export default getUnrelatedNodes;
